import { Component, Input } from '@angular/core';
import { AbstractInputComponent } from '../abstract-input.component';

import { MatError, MatFormField, MatInput, MatPrefix } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlyNumberDirective } from '../../../../utils/directives/only-number-directive';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'logpn-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  imports: [
    MatFormField,
    MatPrefix,
    MatInput,
    FormsModule,
    OnlyNumberDirective,
    ReactiveFormsModule,
    MatError,
    TranslocoPipe
],
})
export class InputNumberComponent extends AbstractInputComponent {
  _max?: number;
  _maxLength?: number;

  @Input() set max(max: number) {
    this._max = max;
    this._maxLength = max.toString().length;
  }
}
